import { PointsTransaction, PointsTransactionCategory } from '@aslanpay/portal-common-lib';

import { createColumnHelper, HeaderContext } from '@tanstack/react-table';

import { format, parseISO } from 'date-fns';

import { Badge, Text } from '@chakra-ui/react';

import TextWithClipboard from 'app/components/UI/TextWithClipboard';

import { PointsTransactionColumns } from 'app/constants/table';
import {
  PointsTransactionCategoryValues,
  getPointsTransactionReasonLabel,
} from 'app/constants/pointsTransactions';

function getPointsTransactionsColumns() {
  const columnHelper = createColumnHelper<PointsTransaction>();

  const columns = Object.keys(PointsTransactionColumns).map((field) => {
    return columnHelper.accessor(field as keyof PointsTransaction, {
      cell: ({ row, getValue }) => {
        const value = getValue();

        switch (field as keyof PointsTransaction) {
          case 'id':
          case 'moneyTransactionId':
            return value && <TextWithClipboard value={value as string} />;
          case 'amount':
            return (
              <Text
                textAlign="right"
                color={
                  row.original.transactionDirection === 'CREDIT' ? 'system.success' : 'system.error'
                }
              >{`${row.original.transactionDirection === 'CREDIT' ? '+' : '-'}${value}`}</Text>
            );
          case 'balance':
            return <Text textAlign="right">{value}</Text>;
          case 'transactionReason':
            return value ? (
              <Text textStyle="extraSmallBold">
                {getPointsTransactionReasonLabel(value as string)}
              </Text>
            ) : null;
          case 'transactionCategory':
            return (
              <Badge
                colorScheme={`badge.${
                  PointsTransactionCategoryValues[value as PointsTransactionCategory]?.color
                }`}
              >
                {PointsTransactionCategoryValues[value as PointsTransactionCategory]?.value}
              </Badge>
            );
          case 'notes':
            return (
              <Text minW="200px" sx={{ wordWrap: 'break-word' }} whiteSpace="normal">
                {value}
              </Text>
            );
          case 'createdAt':
            return value ? (
              <Text>{format(parseISO(value as string), 'dd/MM/yyyy HH:mm:ss')}</Text>
            ) : (
              ''
            );
          default:
            return value;
        }
      },
      header: PointsTransactionColumns[field as keyof typeof PointsTransactionColumns],
      meta: {
        getHeaderContext: (context: HeaderContext<PointsTransaction, unknown>) => {
          if (['amount', 'balance'].includes(context.header.id)) {
            return { style: { justifyContent: 'end' } };
          }
          return undefined;
        },
      },
    });
  });

  return columns;
}

export default getPointsTransactionsColumns;
